import { BaseService } from '@services/BaseService'

const resource = 'hr/surgery'

class SurgeryService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const surgeryService = new SurgeryService()
